import { Box, styled, useMediaQuery } from "@mui/material";
import LanguageSelector from "../languageSelector/LanguageSelector";
import ArrowBackButton from "../navigation/ArrowBackButton";

const Container = styled(Box)(({ theme }) => ({
    display: "flex",
    justifyContent: "space-between",
    padding: theme.spacing(0.5),
    borderBottom: "2px solid #E8E8E8",
    minHeight: "5vh",
    maxHeight: "45px",
    background: theme.palette.background.paper,
}));


const Topbar = () => {
    const isTablet = useMediaQuery("(min-width:700px) and (max-width:900px) and (min-height:1000px) and (max-height:1200px)");
    const isPhone = useMediaQuery("(min-width:350px) and (max-width:420px) and (min-height:600px) and (max-height:950px)");

    let fontSize = 16;
    let marginY = 1
    let marginAvatar = 0

    if (isTablet) {
        fontSize = 20;
        marginY = 3
        marginAvatar = 2.5
    }

    if (isPhone) {
        fontSize = 12;
        marginY = 0
    }

    return (
        <Container>
            <ArrowBackButton></ArrowBackButton>
            <LanguageSelector borderDisabled />
        </Container>
    );
};

export default Topbar;
